import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { distinctUntilChanged, startWith } from 'rxjs/operators';


@Directive({
  selector: '[taghost]'
})
export class TagHostDirective implements OnInit{

  constructor(private ngcontrol: NgControl) { }

  @Output() tagemitter: EventEmitter<any> = new EventEmitter();
  @Input() tagName:any[]

  ngOnInit(): void {
    this.ngcontrol.valueChanges.pipe(startWith(this.ngcontrol.value)).subscribe((dat)=>{
      this.tagemitter.emit({tag:this.ngcontrol.name,value:this.ngcontrol.value,name:this.tagName[0],category:this.tagName[1]})
    })
  }

  

}
